import { IDropDownChecklistUseCase } from "../../../presentation/useCases/read/drop_down_checklist_use_case";
import { GetDropDownChecklistRequestModel, GetDropDownChecklistResponseModel } from "../../models/checklist_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DropDownChecklistUseCase
 */

export class DropDownChecklistUseCase implements IDropDownChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async dropDownChecklist(request: GetDropDownChecklistRequestModel): Promise<GetDropDownChecklistResponseModel[]> {
    return await this.repository.getDropDownChecklist(request);
  }
}
